const windowReducer = (state = [], action) => {
    switch (action.type) {
        case 'WINDOW_WIDTH':
            return {...state, width: action.width};
        case 'WINDOW_HEIGHT':
            return {...state, height: action.height};
        default:
            return state
    }
};

export default windowReducer;


// WEBPACK FOOTER //
// ./src/reducers/window_reducer.js